export class Nomenclature {
    id_nom: string = '-1';
    code: string;
    libelle: string;
    type: string = '';

    constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/models/nomenclature.ts